import React, { ReactNode } from 'react';
import './ButtonComponent.scss';

interface ButtonProps {
  variant?: 'primary' | 'secondary';
  disabled?: boolean;
  onClick?: () => void;
  children: ReactNode;
  className?: string;
  count?: number;
  [key: string]: any; // Allows other props (e.g., data-testid)
}

const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  disabled = false,
  onClick,
  children,
  className = '',
  count,
  ...props
}) => {
  return (
    <button
      className={`button ${variant} ${disabled ? 'disabled' : ''} ${className}`}
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      {children}
      {count !== undefined && count > 0 && (
        <span className="button-count">{count}</span>
      )}
    </button>
  );
};

export default Button;
